import { render, staticRenderFns } from "./bubbleComment.vue?vue&type=template&id=14454ed3&scoped=true&"
import script from "./bubbleComment.vue?vue&type=script&lang=js&"
export * from "./bubbleComment.vue?vue&type=script&lang=js&"
import style0 from "./bubbleComment.vue?vue&type=style&index=0&id=14454ed3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14454ed3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14454ed3')) {
      api.createRecord('14454ed3', component.options)
    } else {
      api.reload('14454ed3', component.options)
    }
    module.hot.accept("./bubbleComment.vue?vue&type=template&id=14454ed3&scoped=true&", function () {
      api.rerender('14454ed3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bubbleComment.vue"
export default component.exports